import Vue from 'vue'
import App from './App.vue'
import router from "@/router";

import 'lib-flexible/flexible.js'
Vue.config.productionTip = false

import store from './assets/store/index'

import Toast from './components/toast/toast'
Vue.prototype.$toast = Toast


import 'mint-ui/lib/style.css'
import "@/assets/css/my-mint.scss"
import { Popup } from 'mint-ui';
import { Picker } from 'mint-ui';
import { Range } from 'mint-ui';
import { Radio ,Checklist} from 'mint-ui';
import {MessageBox} from "mint-ui";
import { Switch } from 'mint-ui';
// import VueTouch from 'vue-touch'

Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(Range.name, Range);
Vue.component(Radio.name, Radio);
Vue.component(Checklist.name, Checklist);
Vue.component(MessageBox.name,MessageBox)
// Vue.use(VueTouch, {name: 'v-touch'})

Vue.component(Switch.name, Switch);


new Vue({
  render: h => h(App),
  router,
  store,//存储
}).$mount('#app')


